/**
 * "أهلًا بك مجددًا" is a lie on the first visit (roundtable 2, S4/B7). This
 * device remembers that someone signed in here before; until then the login
 * page says "أهلًا بك". Per-device on purpose: a seller's first visit on a new
 * phone is still a first visit there.
 */
const KEY = "seller_signed_in_before_v1";

export function hasSignedInBefore(): boolean {
  try {
    return window.localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function markSignedInBefore(): void {
  try {
    window.localStorage.setItem(KEY, "1");
  } catch {
    /* private mode — the greeting stays "أهلًا بك" */
  }
}

const NEEDS_CURRENT_KEY = "seller_first_password_needs_current_v1";

/** An older backend refused the first-login change without the temporary
 *  password; the form asks for it from then on (this tab only). */
export function markFirstPasswordNeedsCurrent(): void {
  try {
    window.sessionStorage.setItem(NEEDS_CURRENT_KEY, "1");
  } catch {
    /* private mode */
  }
}

export function firstPasswordNeedsCurrent(): boolean {
  try {
    return window.sessionStorage.getItem(NEEDS_CURRENT_KEY) === "1";
  } catch {
    return false;
  }
}
